/* tslint:disable */
/* eslint-disable */
/**
 * Bookings API
 * Bookings API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateReservationRequestReservationPolicy
 */
export interface CreateReservationRequestReservationPolicy {
}

/**
 * Check if a given object implements the CreateReservationRequestReservationPolicy interface.
 */
export function instanceOfCreateReservationRequestReservationPolicy(value: object): value is CreateReservationRequestReservationPolicy {
    return true;
}

export function CreateReservationRequestReservationPolicyFromJSON(json: any): CreateReservationRequestReservationPolicy {
    return CreateReservationRequestReservationPolicyFromJSONTyped(json, false);
}

export function CreateReservationRequestReservationPolicyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReservationRequestReservationPolicy {
    return json;
}

export function CreateReservationRequestReservationPolicyToJSON(json: any): CreateReservationRequestReservationPolicy {
    return CreateReservationRequestReservationPolicyToJSONTyped(json, false);
}

export function CreateReservationRequestReservationPolicyToJSONTyped(value?: CreateReservationRequestReservationPolicy | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

